export default __webpack_public_path__ + "static/media/p5-4.1df51266.png";